<template>
  <div>
    <common-dialog ref="dialog" title="投诉处理详情" width="920px" :data="data" :save-func="() => { }"
      :get-data-func="api.info" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <span class>基础信息</span>
        </el-row>
        <el-row class="row-border">
          <el-form-item label="投诉类型" prop>
            <span>{{ data.ComplainType }}</span>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="投诉对象">
              <span>{{ data.MemberName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投诉日期">
              <span>{{ $commonJs.toDateString(data.ComplainDate) }}</span>
            </el-form-item>
          </el-col>
          <el-form-item label="投诉内容">
            <span>{{ data.Content }}</span>
          </el-form-item>
          <el-form-item label="投诉人员">
            <span>{{ data.Anonymous ? "匿名" : data.StudentName }}</span>
          </el-form-item>
          <el-form-item label="处理结果">
            <span>{{ data.Result }}</span>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="处理状态">
              <el-tag type="danger" v-if="data.ResultStatus == 0">未受理</el-tag>
              <el-tag v-if="data.ResultStatus == 1">已受理</el-tag>
              <el-tag type="success" v-if="data.ResultStatus == 2">已处理</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <span v-if="data.ReviewTime != null && data.ReviewTime != ''">审批信息</span>
        <el-row class="row-border" v-if="data.ReviewTime != null && data.ReviewTime != ''">
          <el-col :span="12">
            <el-form-item label="审核人">{{
              data.ReviewUserName
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批时间">{{ data.ReviewTime }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批状态">
              <template v-if="data.ResultStatus == 2">
                <span v-if="data.Status == 0">草稿</span>
                <span v-if="data.Status == 1">待审批</span>
                <span v-if="data.Status == 2">退回</span>
                <span v-if="data.Status == 3">已审批</span>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="
            (data.Status == 0 && data.ReviewRemark != null) ||
            data.Status == 2
          ">
            <el-form-item label="退回原因">{{
              data.ReviewRemark
            }}</el-form-item>
          </el-col>
        </el-row>
        <div>其他信息</div>
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="修改人">{{
              data.UpdateUserName
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">{{ data.AddTime }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建人">
              <span >{{ data.Anonymous ? "匿名" : data.AddUserName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间">{{ data.UpdateTime }}</el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <!-- <template v-if="$permission.canReview()"> -->
        <template v-if="$permission.canReview()  && data.ResultStatus == 2">
          <el-button type="success" @click.stop="pass" v-if="data.Status == 1">通 过</el-button>
          <el-button type="danger" @click.stop="back(1)" v-if="data.Status == 1">退 回</el-button>
          <el-button type="danger" @click.stop="back(2)" v-if="data.Status == 3">撤销审批</el-button>
        </template>
        <el-button @click="onClose">关 闭</el-button>
      </template>
    </common-dialog>
    <return-dialog ref="returnDialog" @confirm="toReturn"></return-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import returnDialog from "@/components/consult/complaint/returnDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    returnDialog,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("loginInfo")),
      api: require("@/api/consult/complaint").default,
      data: {
        ComplainId: 0,
        DpId: 0,
        ComplainType: "",
        MemberType: 0,
        MemberId: 0,
        Content: "",
        ComplainDate: "",
        StudentId: 0,
        Anonymous: true,
        Result: "",
        Status: null,
        ResultStatus: null,
        ResultUserId: 0,
        backType: null,
        ResultTime: "",
        DpName: "",
        DpIdChain: "",
        MemberName: "",
        StudentName: "",
        ReviewUserName: "",
        ReviewRemark: "",
        ReviewTime: "",
        AddTime: "",
        AddUserName: "",
        UpdateUserName: "",
        UpdateTime: "",
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("close-saved");
      this.close(true);
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api
            .pass({ Id: this.data.ComplainId, Type: "同意", Remark: "" })
            .then((res) => {
              this.loading(false);
              if (res.Code == 0) {
                this.$message.success("操作成功");
                this.close();
                this.$emit("close-saved");
              } else {
                this.$message.error(res.Msg);
              }
            });
        })
        .catch(() => { });
    },
    back(t) {
      this.backType = t;
      this.$refs.returnDialog.open(t);
    },
    toReturn(data) {
      this.loading(true);
      if (this.backType == 1) {
        this.api
          .back({
            Id: this.data.ComplainId,
            Type: "退回",
            Remark: data.Remark,
          })
          .then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          });
      } else {
        this.api
          .cancelReview({ Id: this.data.ComplainId, Remark: data.Remark })
          .then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
</style>
